import { CheckmarkCircle03Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import {
  isPartnerCheckInDone,
  shouldShowPartnerCheckInMarker
} from '../lib/partnerCheckInMarker'
import { buildPartnerPageHref } from '../lib/partnerRoute'

export const PartnerCheckInMarker = ({
  id,
  slug,
  checkin_active,
  finished,
  className = ''
}) => {
  const router = useRouter()

  if (!shouldShowPartnerCheckInMarker({ checkin_active, finished })) {
    return null
  }

  const done = isPartnerCheckInDone({ finished })

  const handleClick = event => {
    event.preventDefault()
    event.stopPropagation()
    router.push(buildPartnerPageHref(slug || id))
  }

  return (
    <button
      type="button"
      aria-label={done ? 'Check-in feito' : 'Fazer check-in'}
      onClick={handleClick}
      className={clsx(
        'relative inline-flex shrink-0 items-center justify-center border border-solid transition-all duration-150',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-ring)]',
        'motion-safe:active:scale-[0.96]',
        'after:absolute after:-inset-2 after:content-[""]',
        'gap-1 rounded-lg px-1.5 py-1.5',
        done
          ? 'border-[var(--color-success-light)] bg-[var(--color-success-light)] text-[var(--color-success-text)]'
          : 'border-[var(--color-like-pill-border)] bg-[var(--color-like-pill-surface)] text-gray-700 shadow-sm hover:border-[var(--color-like-pill-hover-border)] hover:bg-[var(--color-like-pill-hover-surface)] hover:text-brand',
        className
      )}
    >
      <CheckmarkCircle03Icon
        size={14}
        variant={done ? 'solid' : 'stroke'}
        className={clsx(
          'relative z-[1] shrink-0 transition-colors duration-150',
          done ? 'text-[var(--color-success-text)]' : 'text-gray-700'
        )}
        aria-hidden
      />

      <span
        className={clsx(
          'relative z-[1] text-xs font-bold leading-none whitespace-nowrap',
          done ? 'text-[var(--color-success-text)]' : 'text-gray-700'
        )}
      >
        Check-in
      </span>
    </button>
  )
}
